import { hexToRgb } from "@mui/material";

export const hexToRgba = (hex, alpha) => {
  const rgb = hexToRgb(hex);
  return `rgba(${rgb.replace("rgb(", "").replace(")", "")}, ${alpha})`;
};
